import Model from "flarum/Model";

export default class U2DiAnnouncement extends Model {}
Object.assign(U2DiAnnouncement.prototype, {
  id: Model.attribute("id"),
  text: Model.attribute("text"),
  status: Model.attribute("status"),
  bilibiliLink: Model.attribute("bilibiliLink"),
  assignedAt: Model.attribute("assignedAt"),
});